import { Component, inject, OnInit } from '@angular/core';
import { EventType, RouterOutlet } from '@angular/router';
import { BrokerDetail, BrokerService } from './services/broker.service';
import { ThemeService } from './services/theme.service';
import pkg from '../../package.json';
import { MsalService } from '@azure/msal-angular';
import { NgIf } from '@angular/common';
import { EventMessage } from '@azure/msal-browser';
import { GlobalLoadingComponent } from './components/global-loading/global-loading.component';
import { AuthStateService } from './services/auth-state.service';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, NgIf, GlobalLoadingComponent],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent implements OnInit{

  private brokerService = inject(BrokerService)
  private themeService = inject(ThemeService)
  private authService= inject(MsalService)
  public authStateService = inject(AuthStateService)

  isLoggedIn = false;
  userName: string | null = null;
  roles: string[] = [];

  title = 'Chill - CCI';
  broker!: BrokerDetail;

  ngOnInit(): void {

  this.updateUserInfo();

    // login event
    this.authService.instance.addEventCallback((event: EventMessage) => {
      if (event.eventType === 'msal:loginSuccess') {
        this.updateUserInfo();
      }
    });
    
    console.warn(`Version: ${pkg.version}`)
    
    this.broker = this.brokerService.getBrokerDetailFromDomain()

    if(this.broker.brokerId == '01'){
      this.themeService.setTheme('chill')
      this.brokerService.applyChillStyle()
    }
    else if(this.broker.brokerId == '04'){
      this.themeService.setTheme('quote-devil')
      this.brokerService.applyQDStyle()
    }
    else{
      this.themeService.setTheme('chill')
      this.brokerService.applyChillStyle()
    }

  }

  private updateUserInfo() {
    const accounts = this.authService.instance.getAllAccounts();
    if (accounts.length > 0) {
      this.isLoggedIn = true;
      this.userName = accounts[0].name || accounts[0].username;
      this.roles = accounts[0].idTokenClaims?.['roles'] || [];
    } else {
      this.isLoggedIn = false;
      this.userName = null;
      this.roles = [];
    }
  }

   login() {
    this.authService.loginRedirect();
  }

  logout() {
    this.authService.logoutRedirect();
  }
 
}
